/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeheaderimporting2Inputs */

const en_placeheaderimporting2 = /** @type {(inputs: Placeheaderimporting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing`)
};

const de_placeheaderimporting2 = /** @type {(inputs: Placeheaderimporting2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird eingelesen`)
};

/**
* | output |
* | --- |
* | "Importing" |
*
* @param {Placeheaderimporting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeheaderimporting2 = /** @type {((inputs?: Placeheaderimporting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeheaderimporting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeheaderimporting2(inputs)
	return de_placeheaderimporting2(inputs)
});
export { placeheaderimporting2 as "placeHeaderImporting" }